import {useMemo, useState} from "react";
import {PipelineFlowEntity} from "@ots-frontend/ots-data";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";
import {useDebouncedValue} from "@mantine/hooks";

export type UsePipelineFlowDataTableFilterProps = Omit<UseDataTableFilterProps<PipelineFlowEntity>, 'filterConfig'>

export function usePipelineFlowDataTableFilter(props: UsePipelineFlowDataTableFilterProps): UseDataTableFilterResult<PipelineFlowEntity> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const [objectQuery, setObjectQuery] = useState<string | undefined>(undefined);
  const [objectDebouncedQuery] = useDebouncedValue(objectQuery, 200);

  const filterConfig: DataTableFilterConfig<PipelineFlowEntity> = useMemo(() => {
    return {
      "object": {
        setQuery: setObjectQuery,
        query: objectQuery,
        debouncedQuery: objectDebouncedQuery,
        filter: (record, query) => !record.objectName || !record.objectName.toLowerCase().includes(query.toLowerCase())
      },
    }
  }, [
    objectQuery,
    objectDebouncedQuery,
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
